(function () {
  'use strict';

  angular
    .module('app.rankingScoreReportExposure')
    .controller('rankingScoreReportExposureCtrl', ['$location', 'measureService', 'exposureReportBestExposureService', '$scope','$rootScope','$http','$filter','filterFilter', '$state', 'localStorageService',
                                    function ($location, measureService, exposureReportBestExposureService, $scope, $rootScope, $http, $filter, filterFilter, $state, localStorageService) {

      function getRankingScoreReportExposures(args) {
        exposureReportBestExposureService.getExposures(args)
        .then(function (data) {
          $scope.exposures = data.exposures;
        })
        .catch(function (msg) {
          $scope.exposures = null;
        })
        .finally(function () {
          $rootScope.$broadcast('sectionLoaded');
        });
      }      

      function getDataRankingScoreReportExposure(args) {
        var currentInfluencer = localStorageService.get('influencerInformation');
        if(currentInfluencer == null || !currentInfluencer.influencerChannels == null || currentInfluencer.influencerChannels.length == 0) {
          return;
        }
        var params = {
                mention : 0,
                blog_id : 0,
                project_id : 0,
                channel: currentInfluencer.influencerChannels[0].id
            };
        params.date = args.date ? args.date.value : $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;
        
        getRankingScoreReportExposures(params);
      }

      $scope.postOverviewPage = function(index){
        $rootScope.previousPagePost = $location.absUrl();
          var module;
          var url_getPlatform = $rootScope.apiUrl + 'overview/getPlatFormPostByRelativepath?relativepath=' + index.relativepath;
          $http.get(url_getPlatform)
              .success(function (response) {
                  if (response.data == 1) {
                      $state.transitionTo('home.blogPostOverview', {url: index.url, relativepath: index.relativepath}, {
                          reload: false,
                          inherit: true,
                          notify: true
                      });
                  } else if (response.data == 2) {
                      $state.transitionTo('home.instagramPostOverview', {url: index.url, relativepath: index.relativepath}, {
                          reload: false,
                          inherit: true,
                          notify: true
                      });
                  } else if (response.data == 6) {
                      $state.transitionTo('home.youtubePostOverview', {url: index.url, relativepath: index.relativepath}, {
                          reload: false,
                          inherit: true,
                          notify: true
                      });
                  } else if (response.data == 7) {
                      $state.transitionTo('home.facebookPostOverview', {url: index.url, relativepath: index.relativepath}, {
                          reload: false,
                          inherit: true,
                          notify: true
                      });
                  }
          })
      }

      $scope.influencerOverviewPage = function(influencer_id){
        $rootScope.previousPage = $location.absUrl();
          $state.transitionTo('home.influencerOverview', {influencer_id: influencer_id}, {
              reload: false,
              inherit: true,
              notify: true
          });
      }

      // first initiating
      getDataRankingScoreReportExposure({});
      
    }]);

})();